import template from './myLoansContextMenu.html';
import controller from './myLoansContextMenu.controller';
import './myLoansContextMenu.scss';

let myLoansContextMenuComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    statusCode: '<',
    onChangeOptionSelected: '&',
    isDateCancellationHigher: '<',
    isDateGrantHigher: '<',
    serviceClosed: '<',
    tempLoanObject: '<',
  },
  template,
  controller,
};

export default myLoansContextMenuComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansContextMenu/myLoansContextMenu.component.js